import React from 'react';
import { HOW_IT_WORKS } from '../../data/mock';
import { CalendarCheck, Phone, Camera } from 'lucide-react';

const iconMap = {
  CalendarCheck: CalendarCheck,
  Phone: Phone,
  Camera: Camera,
};

const HowItWorksSection = () => {
  return (
    <section className="section-padding bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111]">
            How it works
          </h2>
          <p className="mt-4 text-lg text-[#475569]">
            Simple, fast, and designed around your workflow
          </p>
        </div>

        {/* Steps */}
        <div className="mt-10 grid md:grid-cols-3 gap-8 lg:gap-12">
          {HOW_IT_WORKS.map((step, index) => {
            const IconComponent = iconMap[step.icon];
            return (
              <div key={step.step} className="relative">
                {/* Connector Line */}
                {index < HOW_IT_WORKS.length - 1 && (
                  <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-[#E2E8F0]" />
                )}
                
                <div className="relative text-center">
                  {/* Step Circle */}
                  <div className="step-circle mx-auto relative z-10">
                    <IconComponent className="w-6 h-6" />
                  </div>
                  
                  {/* Content */}
                  <div className="mt-6">
                    <span className="text-sm font-semibold text-[#0D9488] uppercase tracking-wider">
                      Step {step.step}
                    </span>
                    <h3 className="mt-2 text-xl font-bold text-[#111111]">
                      {step.title}
                    </h3>
                    <p className="mt-3 text-[#475569] leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Note */}
        <div className="mt-8 text-center">
          <p className="text-sm text-[#64748B] bg-white inline-block px-6 py-3 rounded-full border border-[#E2E8F0]">
            We collect from your customer's location and send you confirmation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
